export const fetchAllCMSAction = data => {
	return {
		type: 'FETCH_ALL_CMS_DATA',
		payload: data
	}
}